import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ParkingPolygonAdmin } from "../components/ParkingPolygonAdmin";
import { getParkingData } from "../lib/parkingDataSource";

const parkingData = getParkingData();

export default function AdminParkingNewPage() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <main className="min-h-screen bg-slate-50 px-4 py-16 text-slate-900 transition-colors dark:bg-neutral-950 dark:text-slate-100">
        <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-[0_20px_60px_-30px_rgba(15,23,42,0.15)] transition-colors dark:border-white/10 dark:bg-neutral-900/80">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-amber-500">Brak uprawnień</p>
          <h1 className="text-3xl font-semibold tracking-tight text-slate-800 dark:text-slate-50">Dostęp zabroniony</h1>
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Twoje konto nie posiada uprawnień administracyjnych do dodawania parkingów. Skontaktuj się z administratorem lub wróć do panelu głównego.
          </p>
          <Link
            to="/"
            className="mx-auto inline-flex items-center gap-2 rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold uppercase tracking-[0.25em] text-slate-600 transition hover:border-emerald-500 hover:bg-emerald-50 hover:text-emerald-600 dark:border-white/10 dark:text-slate-200 dark:hover:border-emerald-400 dark:hover:bg-emerald-400/10 dark:hover:text-emerald-300"
          >
            Wróć do panelu
          </Link>
        </div>
      </main>
    );
  }

  return <ParkingPolygonAdmin parkingData={parkingData} />;
}
